import { FindFilter } from '../$models'
import { flattenObject } from './flattenObject'

export const isValidFilterCondObject = (cond: FindFilter): boolean => {
  return Object.values(flattenObject(cond)).filter((v) => v !== undefined).length > 0
}
